import React from "react";
import "../Styles.css";
import { UseGlobalState } from "../../state/gsh/gsh";

import { USERPW_PANE } from "./constants";
import { PROJECT_PROFILE } from "../../constants/storageKeys";
import { debugLog } from "../../util/debug";

export default function UserPWPane(props) {
  const { clickFunc } = props;

  const state = UseGlobalState()[0];
  const [imgUrl, setImgUrl] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  React.useEffect(() => {
    const profileStr = window.localStorage.getItem(PROJECT_PROFILE);
    if (!!profileStr) {
      const profile = JSON.parse(profileStr);
      const src = profile.branding?.imageUrls?.logo;
      setImgUrl(src);
    }
  }, [state.selectedDomain, state.isBrandingSet]);

  const handleClick = () => {
    clickFunc(
      document.getElementById("cnxt-un").value,
      document.getElementById("cnxt-pwd").value,
      setErrorMessage
    );
  };

  return (
    <div>
      {loading && (
        <div class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-40 overflow-hidden bg-white flex flex-col items-center justify-center">
          <div class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"></div>
        </div>
      )}
      {state.loginPane === USERPW_PANE && (
        <div className="reactModalProgURL">
          <div>
            {!!imgUrl && <img className="logo-image" src={imgUrl} alt="logo" />}
          </div>
          <br />
          <div className="loginModalProgURLBody0">
            <div className="loginModalProgURLBody7">
              Welcome to our engagement community.
              <br />
              What connection will you make today to advance our purpose? <br />
            </div>
            <div>
              <input
                className="loginModalProgURLUserPwdBody3"
                type="text"
                placeholder="user name"
                id="cnxt-un"
              ></input>
              <br />
              <br />
              <input
                className="loginModalProgURLUserPwdBody3"
                type="password"
                placeholder="password"
                id="cnxt-pwd"
              ></input>
            </div>
            {errorMessage && (
              <div className="loginModalError">
                <span> {errorMessage} </span>
              </div>
            )}
            <br />
            <div>
              <button
                className="loginModalProgURLUserPwdBody4 border border-solid border-slate-500 rounded primary-btn"
                onClick={handleClick}
              >
                Login
              </button>
            </div>

            <div className="loginModalProgURLBody9">
              <span>
                Forgot Network ID or Password? Please access your program
                website to reset.
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
